import { Box, SxProps, Theme } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import { Info } from '@sweep-io/sweep-design/dist/icons';

interface ArtifactUnavailableStateProps {
  /**
   * Variant affects typography sizes:
   * - 'page': larger (h1, h4) for full-page contexts
   * - 'panel': smaller (h2, body) for side panel contexts
   */
  variant?: 'page' | 'panel';
  infoDescription?: string;
  sx?: SxProps<Theme>;
}

const defaultDescriptions = {
  page: "You're either logged in a different account than which the artifact was shared from, or this artifact has been deleted by its owner.",
  panel:
    'The artifact content could not be loaded. It may have been deleted or failed to generate properly.',
};

export const ArtifactUnavailableState = ({
  variant = 'panel',
  infoDescription,
  sx,
}: ArtifactUnavailableStateProps) => {
  const isPage = variant === 'page';
  const description = infoDescription ?? defaultDescriptions[variant];

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.grey[100],
        m: 2,
        ...(isPage ? {} : { borderRadius: '8px' }),
        ...sx,
      }}
    >
      <Box sx={{ textAlign: 'center', padding: 3 }}>
        <Box sx={{ marginBottom: '16px' }}>
          <Typography variant={isPage ? 'h1' : 'h2'}>Artifact Unavailable</Typography>
        </Box>
        <Box sx={{ marginBottom: '24px' }}>
          <Typography variant={isPage ? 'h4' : 'body'} color={colors.grey[700]}>
            This artifact is currently unavailable.
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1,
            backgroundColor: 'white',
            padding: 2,
            borderRadius: '8px',
            textAlign: 'left',
            flexDirection: 'column',
            ...(isPage && { width: '460px', margin: '0 auto' }),
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Info />
            <Typography variant={isPage ? 'h5-medium' : 'body-medium'}>What happened?</Typography>
          </Box>
          <Typography variant="body" color={colors.grey[700]}>
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
